<template>
  <a-tabs v-model:activeKey="tabType" @change="checkPic = 1">
    <a-tab-pane :key="7" tab="未注册"></a-tab-pane>
    <a-tab-pane :key="8" tab="注册成功"></a-tab-pane>
  </a-tabs>
  <div v-if="tabType === 7" class="df">
    <div class="df subscription">
      <div>
        <div class="w500 mb20">
          <div class="mb4"><span class="red">*</span>活动主题：</div>
          <a-input
            class="w300"
            v-model:value="popupSet7.subjectName"
            placeholder="请输入（建议18个字符以内）"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4"><span class="red">*</span>优惠券数：</div>
          <a-radio-group
            :options="[
              { value: 1, label: '1张' },
              { value: 2, label: '2张' }
            ]"
            v-model:value="popupSet7.couponNum"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4">优惠券1标题：</div>
          <a-input
            class="w300"
            v-model:value="
              langsList[langsList.findIndex(v => v.langCode === langCode)]
                .popupTextCouponDTOList7[0].couponName
            "
            placeholder="请输入（建议14个字符以内）"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4">优惠券1副标题：</div>
          <a-input
            class="w300"
            v-model:value="
              langsList[langsList.findIndex(v => v.langCode === langCode)]
                .popupTextCouponDTOList7[0].couponViceName
            "
            placeholder="请输入（建议18个字符以内）"
          />
        </div>
        <div class="w500 mb20" v-if="popupSet7.couponNum === 2">
          <div class="mb4">优惠券2标题：</div>
          <a-input
            class="w300"
            v-model:value="
              langsList[langsList.findIndex(v => v.langCode === langCode)]
                .popupTextCouponDTOList7[1].couponName
            "
            placeholder="请输入（建议14个字符以内）"
          />
        </div>
        <div class="w500 mb20" v-if="popupSet7.couponNum === 2">
          <div class="mb4">优惠券2副标题：</div>
          <a-input
            class="w300"
            v-model:value="
              langsList[langsList.findIndex(v => v.langCode === langCode)]
                .popupTextCouponDTOList7[1].couponViceName
            "
            placeholder="请输入（建议18个字符以内）"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4"><span class="red">*</span>BUTTON 名称：</div>
          <a-input
            class="w300"
            v-model:value="popupSet7.buttonText"
            placeholder="请输入（建议12个字符以内）"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4">文案提示</div>
          <quillEditor
            v-model:value="popupSet7.promptText"
            style="height: 100px; width: 500px;"
            :options="editorOption"
            laceholder="请输入（建议90个字符以内）"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4"><span class="red">*</span>背景图：</div>
          <div class="df">
            <div class="mr20">
              <div class="w120 h120 mb10 pr">
                <a-upload-dragger
                  :fileList="[]"
                  :show-upload-list="false"
                  name="file"
                  :multiple="true"
                  :customRequest="e => upload(e, 7, 'popupSet7_pc')"
                  :accept="'.png,.jpg,.jpeg,.gif'"
                  :headers="uploadHeaders"
                >
                  <div v-if="['', null].includes(popupSet7.pcImgUrl)">
                    <div
                      class="w120 h120 tac"
                      style="color: #666666; font-size: 40px; line-height: 120px;"
                    >
                      <PictureOutlined />
                    </div>
                  </div>
                </a-upload-dragger>
                <div
                  v-if="!['', null].includes(popupSet7.pcImgUrl)"
                  class="h120 pa l0 t0 sidebarContentBg"
                  :style="
                    `width: 120px; background: url('${popupSet7.pcImgUrl}') center center/ cover no-repeat;`
                  "
                >
                  <div class="hover">
                    <EyeOutlined
                      @click="() => changeVisiblePic(true, popupSet7.pcImgUrl)"
                    />
                    &nbsp;&nbsp;
                    <DeleteOutlined @click="popupSet7.pcImgUrl = null" />
                  </div>
                </div>
              </div>
              <div class="tac">PC端(三倍图)</div>
              <div class="tac">1680 × 780</div>
              <MaterialSelectionListModal
                style="margin: 10px"
                @submit="val => handleSubmit(val, 7, 'popupSet7_pc')"
                :validateImageOrVideoArea="['560*260']"
                :validateImageOrVideoFormatAndSizeByMB="{
                  jpg: 0.5,
                  png: 0.5,
                  gif: 10,
                  jpeg: 0.5,
                  'image/jpeg': 0.5,
                  'image/png': 0.5,
                  'image/gif': 10,
                  'image/jpg': 0.5
                }"
                :fileterResourceType="1"
                :siteId="Number(queryParams?.siteId)"
                :terminalId="Number(queryParams?.terminalId)"
                :subTerminalId="Number(queryParams?.terminalId)"
              />
            </div>
            <div>
              <div class="w120 h120 mb10 pr">
                <a-upload-dragger
                  :fileList="[]"
                  :show-upload-list="false"
                  name="file"
                  :multiple="true"
                  :customRequest="e => upload(e, 7, 'popupSet7_m')"
                  :accept="'.png,.jpg,.jpeg,.gif'"
                  :headers="uploadHeaders"
                >
                  <div v-if="['', null].includes(popupSet7.mImgUrl)">
                    <div
                      class="w120 h120 tac"
                      style="color: #666666; font-size: 40px; line-height: 120px;"
                    >
                      <PictureOutlined />
                    </div>
                  </div>
                </a-upload-dragger>
                <div
                  v-if="!['', null].includes(popupSet7.mImgUrl)"
                  class="h120 pa l0 t0 sidebarContentBg"
                  :style="
                    `width: 120px; background: url('${popupSet7.mImgUrl}') center center/ cover no-repeat;`
                  "
                >
                  <div class="hover">
                    <EyeOutlined
                      @click="() => changeVisiblePic(true, popupSet7.mImgUrl)"
                    />
                    &nbsp;&nbsp;
                    <DeleteOutlined @click="popupSet7.mImgUrl = null" />
                  </div>
                </div>
              </div>
              <div class="tac">M端(三倍图)</div>
              <div class="tac">1125 × 720</div>
              <MaterialSelectionListModal
                style="margin: 10px"
                @submit="val => handleSubmit(val, 7, 'popupSet7_m')"
                :validateImageOrVideoArea="['375*240']"
                :validateImageOrVideoFormatAndSizeByMB="{
                  jpg: 0.3,
                  png: 0.3,
                  gif: 10,
                  jpeg: 0.3,
                  'image/jpeg': 0.3,
                  'image/png': 0.3,
                  'image/gif': 10,
                  'image/jpg': 0.3
                }"
                :fileterResourceType="1"
                :siteId="Number(queryParams?.siteId)"
                :terminalId="Number(queryParams?.terminalId)"
                :subTerminalId="2"
              />
            </div>
          </div>
        </div>
        <div class="w500 mb20 mt20">
          <div class="mb4">是否展示偏好：</div>
          <a-radio-group
            name="radioGroup"
            v-model:value="popupSet7.showPersonalPreference"
          >
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </div>
      </div>
    </div>
    <div class="EditContainerRight">
      <div class="checkPicTabs mb20">
        <div
          :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
          @click="() => checkPicChange(1)"
        >
          PC端
        </div>
        <div
          :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
          @click="() => checkPicChange(2)"
        >
          M端
        </div>
      </div>
      <div class="pic" v-if="checkPic === 1">
        <img
          :src="ur01"
          style="width: 100%;"
          class="mb20"
          v-if="popupSet7.couponNum === 1"
        />
        <img
          :src="ur02"
          style="width: 100%;"
          v-if="popupSet7.couponNum === 2"
        />
        <img
          :src="ur05"
          style="width: 100%;"
          v-if="popupSet7.showPersonalPreference"
        />
      </div>
      <div class="pic" v-if="checkPic === 2">
        <img
          :src="ur03"
          style="width: 100%;"
          class="mb20"
          v-if="popupSet7.couponNum === 1"
        />
        <img
          :src="ur04"
          style="width: 100%;"
          v-if="popupSet7.couponNum === 2"
        />
        <img
          :src="ur05"
          style="width: 100%;"
          v-if="popupSet7.showPersonalPreference"
        />
      </div>
    </div>
  </div>
  <div v-if="tabType === 8" class="df">
    <div class="df subscription">
      <div>
        <div class="w500 mb20">
          <div class="mb4"><span class="red">*</span>活动主题：</div>
          <a-input
            class="w300"
            v-model:value="popupSet8.subjectName"
            placeholder="请输入（建议18个字符以内）"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4"><span class="red">*</span>优惠券数：</div>
          <a-radio-group
            :options="[
              { value: 1, label: '1张' },
              { value: 2, label: '2张' }
            ]"
            v-model:value="popupSet8.couponNum"
          />
        </div>
        <div>
          <div class="w500 mb20">
            <div class="mb4">优惠券1标题：</div>
            <a-input
              class="w300"
              v-model:value="
                langsList[langsList.findIndex(v => v.langCode === langCode)]
                  .popupTextCouponDTOList8[0].couponName
              "
              placeholder="请输入（建议14个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">优惠券1副标题：</div>
            <a-input
              class="w300"
              v-model:value="
                langsList[langsList.findIndex(v => v.langCode === langCode)]
                  .popupTextCouponDTOList8[0].couponViceName
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">优惠券1折扣码：</div>
            <a-input
              class="w300"
              v-model:value="
                langsList[langsList.findIndex(v => v.langCode === langCode)]
                  .popupTextCouponDTOList8[0].couponCode
              "
              placeholder="请输入（建议12个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              优惠券1折扣码复制文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                langsList[langsList.findIndex(v => v.langCode === langCode)]
                  .popupTextCouponDTOList8[0].couponCopyText
              "
              placeholder="请输入（建议50个字符以内）"
            />
          </div>
        </div>
        <div v-if="popupSet8.couponNum === 2">
          <div class="w500 mb20">
            <div class="mb4">优惠券2标题：</div>
            <a-input
              class="w300"
              v-model:value="
                langsList[langsList.findIndex(v => v.langCode === langCode)]
                  .popupTextCouponDTOList8[1].couponName
              "
              placeholder="请输入（建议14个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">优惠券2副标题：</div>
            <a-input
              class="w300"
              v-model:value="
                langsList[langsList.findIndex(v => v.langCode === langCode)]
                  .popupTextCouponDTOList8[1].couponViceName
              "
              placeholder="请输入（建议18个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">优惠券2折扣码：</div>
            <a-input
              class="w300"
              v-model:value="
                langsList[langsList.findIndex(v => v.langCode === langCode)]
                  .popupTextCouponDTOList8[1].couponCode
              "
              placeholder="请输入（建议12个字符以内）"
            />
          </div>
          <div class="w500 mb20">
            <div class="mb4">
              优惠券2折扣码复制文案：
            </div>
            <a-input
              class="w300"
              v-model:value="
                langsList[langsList.findIndex(v => v.langCode === langCode)]
                  .popupTextCouponDTOList8[1].couponCopyText
              "
              placeholder="请输入（建议50个字符以内）"
            />
          </div>
        </div>
        <div class="w500 mb20">
          <div class="mb4"><span class="red">*</span>BUTTON 名称：</div>
          <a-input
            class="w300"
            v-model:value="popupSet8.buttonText"
            placeholder="请输入（建议16个字符以内）"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4"><span class="red">*</span>BUTTON 点击跳转链接：</div>
          <a-input
            class="w300"
            v-model:value="popupSet8.buttonLink"
            placeholder="请输入（建议500个字符以内）"
          />
        </div>
        <div class="w500 mb20 mt20">
          <div class="mb4">是否展示偏好：</div>
          <a-radio-group
            name="radioGroup"
            v-model:value="popupSet8.showPersonalPreference"
          >
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </div>
      </div>
    </div>
    <div class="EditContainerRight">
      <div class="checkPicTabs mb20">
        <div
          :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
          @click="() => checkPicChange(1)"
        >
          PC端
        </div>
        <div
          :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
          @click="() => checkPicChange(2)"
        >
          M端
        </div>
      </div>
      <div class="pic" v-if="checkPic === 1">
        <img
          :src="ur01"
          style="width: 100%;"
          class="mb20"
          v-if="popupSet8.couponNum === 1"
        />
        <img
          :src="ur02"
          style="width: 100%;"
          v-if="popupSet8.couponNum === 2"
        />
      </div>
      <div class="pic" v-if="checkPic === 2">
        <img
          :src="ur03"
          style="width: 100%;"
          class="mb20"
          v-if="popupSet8.couponNum === 1"
        />
        <img
          :src="ur04"
          style="width: 100%;"
          v-if="popupSet8.couponNum === 2"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { quillEditor } from 'vue3-quill'
import { toRefs, inject, reactive } from 'vue'
import {
  EyeOutlined,
  PictureOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue'
export default {
  components: {
    quillEditor,
    DeleteOutlined,
    EyeOutlined,
    PictureOutlined
  },
  setup() {
    const state = reactive({
      checkPicChange: (checkPic = 1) => {
        state.checkPic = checkPic
      },
      checkPic: 1
    })
    return {
      checkboxOptions: [
        {
          label: '默认勾选',
          value: true
        },
        {
          label: '默认不勾选',
          value: false
        }
      ],
      ur01:
        'https://cdn-shopify.cupshe.com/shopify/0f62f99b-1854-4c11-b1c4-53c4de103d4f/ur-01.png',
      ur02:
        'https://cdn-shopify.cupshe.com/shopify/846e9ec5-6fc0-4c38-a5c6-5036d9e7f26b/ur-02.png',
      ur03:
        'https://cdn-shopify.cupshe.com/shopify/529aa8f7-0ed0-4920-978b-f54537119802/ur-03.png',
      ur04:
        'https://cdn-shopify.cupshe.com/shopify/7f14ca24-ccb6-4e03-bdaf-75e16c76e287/ur-04.png',
      ur05:
        'https://cdn-image.kapeixi.cn/web/d421d695-4541-4bc8-a22a-9992f0088936/PC3.png',
      re01:
        'https://cdn-shopify.cupshe.com/shopify/816b8102-19cb-4383-ac27-6183fb2578f7/rs-01.png',
      re02:
        'https://cdn-shopify.cupshe.com/shopify/68763c54-d5dd-4945-a230-5054696c7350/rs-02.png',
      re03:
        'https://cdn-shopify.cupshe.com/shopify/6480a75d-bb3e-431c-b44b-4ab3b382a33f/rs-03.png',
      re04:
        'https://cdn-shopify.cupshe.com/shopify/6f3061ff-251b-46ac-966e-e7c66fafdcdc/rs-04.png',
      re05:
        'https://cdn-image.kapeixi.cn/web/5f073152-752b-438d-9458-25b81d0bf925/M3.png',
      ...toRefs(inject('initState')),
      editorOption: {
        placeholder: '请输入',
        modules: {
          toolbar: [
            [
              {
                font: [
                  'Muli-Light',
                  'Muli-SemiBold',
                  'Muli-Bold',
                  'Muli-ExtraBold'
                ]
              }
            ],
            [
              {
                size: [
                  '12px',
                  '14px',
                  '16px',
                  '18px',
                  '20px',
                  '22px',
                  '24px',
                  '26px',
                  '28px',
                  '30px',
                  '32px',
                  '34px',
                  '36px',
                  '38px',
                  '40px'
                ]
              }
            ],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E'
                ]
              }
            ]
          ]
        }
      }
    }
  }
}
</script>
<style scoped>
.checkPicTabs {
  width: 146px;
  height: 36px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
  margin: 0 auto 20px auto;
}

.checkPicTab {
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
}

.checkPicTab.check {
  background: #ffffff;
}

.EditContainerRight {
  background: #f4f4f4;
  width: 400px;
  padding: 14px;
  margin: 14px;
}

.checkPics {
  height: 560px;
}

.sidebarContentBg .hover {
  width: 120px;
  height: 120px;
  display: none;
  cursor: pointer;
  color: #ffffff;
  text-align: center;
  line-height: 120px;
  background: rgba(0, 0, 0, 0.3);
}

.sidebarContentBg:hover .hover {
  display: block;
}
</style>
<style>
.subscription .ant-upload.ant-upload-drag .ant-upload {
  padding: 0;
}
</style>
